import styled from "styled-components"

export const SelectionWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    @media only screen and (max-device-width : 600px){
        display: block;
    }
`
export const SelectionItem = styled.div`
    display: flex;
    alignItems: center; 
    flex:50%;
    padding: 15px 1%;

    & a{
        display: flex;
    }
`
export const SelectionFlag = styled.img`
    marginRight: 5px;
    width: 27px; 
    height: 17px
`

export const SelectionName = styled.span`
    padding-left:10px
`